// extracted by mini-css-extract-plugin
export default {"gray-10":"rgb(242, 243, 248)","gray-60":"rgb(105, 111, 119)","indicator":"styles_indicator__m8dZX"};